(function(){
  'use strict';

  angular.module('eclipseApp.checkout').directive('validateCvv', ['buyUtils', 'uteSemafoneService', function(buyUtils, uteSemafoneService){
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elem, attr, ctrl){

        // EC-4127
        // EC 376: Issues in change MOP from credit card to another Credit card.
        ctrl.$validators.format = function(modelVal, viewVal){
          if (modelVal && modelVal.toString().length >= 3) {
            return (parseInt(modelVal.toString().length) === parseInt(uteSemafoneService.getExpectedSecurityCodeLength()));
          } else {
            return false;
          }
        };

        scope.$on('Event:SFEvents:Tokenized', function(ev){

          if (ctrl.$viewValue) {
            ctrl.$setValidity('format', (parseInt(ctrl.$viewValue.toString().length) === parseInt(uteSemafoneService.getExpectedSecurityCodeLength())));
            scope.$digest();
          }
        });
        // /EC-4127
      }
    };
  }]);
})();
